import React from "react";
import Button, { ButtonsProps } from "../Buttons/Button";
import {
  GatsbyImage,
  GatsbyImageProps,
  StaticImage,
} from "gatsby-plugin-image";
import SlantSection from "../Slant/Slant";

export interface TextProps {
  color: string;
  text: string;
  colorMobile?: string;
}
interface Props {
  backgroundColor: string;
  heading?: TextProps;
  subText?: TextProps;
  button1?: ButtonsProps;
  image?: any;
  children?: React.ReactNode;
  reverse?: boolean;
}

const GetUpToSection = ({
  backgroundColor,
  image,
  heading,
  subText,
  button1,
  children,
  reverse,
}: Props) => {
  return (
    <SlantSection
      variant="full"
      background={backgroundColor}
      sx={{
        alignItems: "center",
        justifyContent: "center",
        pb: [50, null, null, 170],
        px: [4, null, null, 6],
        pt: [5, null, null, null, "6vw"],
        zIndex: 2,
      }}
    >
      <div
        sx={{
          maxWidth: 1920,
          display: "flex",
          flexwrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: [
            "column",
            null,
            null,
            reverse ? "row-reverse" : "row",
          ],
        }}
      >
        <div
          data-sal={"zoom-in"}
          data-sal-easing="easeOutQuart"
          data-sal-duration={1000}
          data-sal-delay="300"
        >
          {image ? (
            image
          ) : (
            <StaticImage
              src="../../images/home/getupto10000.png"
              alt="Get up to $10,000"
              layout="constrained"
              placeholder="none"
              width={689}
              sx={{
                minWidth: [300],
                maxWidth: 500,
              }}
            />
          )}
        </div>
        {children ? (
          children
        ) : (
          <div
            sx={{
              maxWidth: ["100%", null, null, "50%"],
              pl: [0, null, null, 90],
            }}
          >
            {heading && (
              <h2
                data-sal={"slide-right"}
                data-sal-easing="easeOutQuart"
                data-sal-duration={1000}
                data-sal-delay="200"
                sx={{
                  fontWeight: 600,
                  color: heading.color,
                  py: 0,
                }}
              >
                {heading.text}
              </h2>
            )}
            {subText && (
              <p
                data-sal={"slide-right"}
                data-sal-easing="easeOutQuart"
                data-sal-duration={1000}
                data-sal-delay="250"
                sx={{
                  color: subText.color,
                  pb: 3,
                }}
              >
                {subText.text}
              </p>
            )}
            <div
              data-sal={"slide-right"}
              data-sal-easing="easeOutQuart"
              data-sal-duration={1000}
              data-sal-delay="260"
            >
              <Button {...button1} />
            </div>
          </div>
        )}
      </div>
    </SlantSection>
  );
};

export default GetUpToSection;
